/* customized primeNG toast component */
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { computed, DestroyRef, effect, ElementRef, EventEmitter, inject, input, TemplateRef } from '@angular/core';
import { MinimalUiModule } from '@common/ui/frontend-shared';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiProgressBarComponent } from '@common/ui/frontend-shared/progressbar';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { clamp, StopWatchObservable } from '@core/shared/utils';
import { map, skipWhile, takeUntil } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../ui/frontend-shared/src/lib/icons/icon.component";
const _c0 = ["container"];
const _c1 = (a0, a1) => ({
  showTransitionParams: a0,
  hideTransitionParams: a1
});
const _c2 = a0 => ({
  value: "visible",
  params: a0
});
const _c3 = a0 => ({
  $implicit: a0
});
function AppMessageComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-progressBar", 2);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", i0.ɵɵpipeBind1(1, 1, ctx_r0.lifeInPercent$) * 100);
  }
}
function AppMessageComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵlistener("click", function AppMessageComponent_Conditional_0_Conditional_4_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onCloseIconClick($event));
    })("keydown.enter", function AppMessageComponent_Conditional_0_Conditional_4_Template_a_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onCloseIconClick($event));
    });
    i0.ɵɵelement(1, "ui-icon", 7);
    i0.ɵɵelementEnd();
  }
}
function AppMessageComponent_Conditional_0_Conditional_5_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const msg_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(msg_r3.duplicateCount + 1);
  }
}
function AppMessageComponent_Conditional_0_Conditional_5_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
  if (rf & 2) {
    const msg_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", msg_r3.detail, i0.ɵɵsanitizeHtml);
  }
}
function AppMessageComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 8);
    i0.ɵɵelementStart(1, "div", 9)(2, "div", 10)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(5, AppMessageComponent_Conditional_0_Conditional_5_Conditional_5_Template, 3, 1, "span");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(6, AppMessageComponent_Conditional_0_Conditional_5_Conditional_6_Template, 1, 1, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const msg_r3 = i0.ɵɵnextContext();
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r0.icon());
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(msg_r3.summary);
    i0.ɵɵadvance();
    i0.ɵɵconditional(msg_r3.duplicateCount > 0 ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(msg_r3.detail ? 6 : -1);
  }
}
function AppMessageComponent_Conditional_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AppMessageComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1, 0);
    i0.ɵɵconditionalCreate(2, AppMessageComponent_Conditional_0_Conditional_2_Template, 2, 3, "ui-progressBar", 2);
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵconditionalCreate(4, AppMessageComponent_Conditional_0_Conditional_4_Template, 2, 0, "a", 4);
    i0.ɵɵconditionalCreate(5, AppMessageComponent_Conditional_0_Conditional_5_Template, 7, 4);
    i0.ɵɵtemplate(6, AppMessageComponent_Conditional_0_ng_container_6_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const msg_r3 = ctx;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@messageState", i0.ɵɵpureFunction1(10, _c2, i0.ɵɵpureFunction2(7, _c1, ctx_r0.showTransitionOptions(), ctx_r0.hideTransitionOptions())))("ngClass", ctx_r0.messageClasses());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.isSticky() ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(msg_r3.closable !== false ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.template() ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template())("ngTemplateOutletContext", i0.ɵɵpureFunction1(12, _c3, msg_r3));
  }
}
export let AppMessageComponent = /*#__PURE__*/(() => {
  class AppMessageComponent {
    constructor() {
      this.destroyRef = inject(DestroyRef);
      this.message = input.required(...(ngDevMode ? [{
        debugName: "message"
      }] : /* istanbul ignore next */[]));
      this.index = input(0, ...(ngDevMode ? [{
        debugName: "index"
      }] : /* istanbul ignore next */[]));
      this.template = input(null, ...(ngDevMode ? [{
        debugName: "template"
      }] : /* istanbul ignore next */[]));
      this.showTransitionOptions = input('300ms ease-out', ...(ngDevMode ? [{
        debugName: "showTransitionOptions"
      }] : /* istanbul ignore next */[]));
      this.hideTransitionOptions = input('250ms ease-in', ...(ngDevMode ? [{
        debugName: "hideTransitionOptions"
      }] : /* istanbul ignore next */[]));
      // Use message.sticky or autoClose=false to ensure a message wont time out.
      // use pauseLifeTime to temporarily pause a already running message timeout.
      this.autoClose = input(true, ...(ngDevMode ? [{
        debugName: "autoClose"
      }] : /* istanbul ignore next */[]));
      this.pauseLifeTime = input(false, ...(ngDevMode ? [{
        debugName: "pauseLifeTime"
      }] : /* istanbul ignore next */[]));
      this.pauseLifeTimeHandler = effect(() => {
        const paused = this.pauseLifeTime();
        if (paused) this.stopwatch.pause();else this.stopwatch.start();
      }, ...(ngDevMode ? [{
        debugName: "pauseLifeTimeHandler"
      }] : /* istanbul ignore next */[]));
      this.icon = computed(() => {
        const message = this.message();
        if (!message) return null;
        if (message.severity === 'success') return 'check';
        if (message.severity === 'info') return 'info-circle';
        if (message.severity === 'warn') return 'exclamation-triangle';
        if (message.severity === 'error') return 'exclamation-triangle';
        return null;
      }, ...(ngDevMode ? [{
        debugName: "icon"
      }] : /* istanbul ignore next */[]));
      this.isSticky = computed(() => {
        return this.message().sticky || !this.autoClose();
      }, ...(ngDevMode ? [{
        debugName: "isSticky"
      }] : /* istanbul ignore next */[]));
      this.messageClasses = computed(() => {
        const classes = ['p-toast-message p-shadow'];
        classes.push('p-toast-message-' + this.message().severity);
        if (this.message().sticky) classes.push('sticky');else classes.push('has-lifetime');
        return classes.join(' ');
      }, ...(ngDevMode ? [{
        debugName: "messageClasses"
      }] : /* istanbul ignore next */[]));
      this.onClose = new EventEmitter();
      this.updateInterval = 100;
      this.stopwatch = new StopWatchObservable(this.updateInterval);
    }
    ngAfterViewInit() {
      this.setupLifetime();
    }
    setupLifetime() {
      if (!this.isSticky()) {
        const lifeTime = this.message().life || 3000;
        this.endOfLife$ = this.stopwatch.update.pipe(takeWhileAlive(this.destroyRef), skipWhile(ms => ms < lifeTime));
        this.lifeInPercent$ = this.stopwatch.update.pipe(takeWhileAlive(this.destroyRef), takeUntil(this.endOfLife$), map(ms => {
          const percentage = ms / lifeTime;
          return clamp(percentage, 0, 1);
        }));
        this.stopwatch.start();
        this.endOfLife$.subscribe(() => {
          this.stopwatch.destroy();
          this.onClose.emit({
            index: this.index(),
            message: this.message()
          });
        });
      }
    }
    onCloseIconClick(event) {
      this.stopwatch?.destroy();
      this.onClose.emit({
        index: this.index(),
        message: this.message()
      });
      event.preventDefault();
    }
    ngOnDestroy() {
      this.stopwatch?.destroy();
    }
    static {
      this.ɵfac = function AppMessageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppMessageComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: AppMessageComponent,
        selectors: [["app-message"]],
        viewQuery: function AppMessageComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerViewChild = _t.first);
          }
        },
        inputs: {
          message: [1, "message"],
          index: [1, "index"],
          template: [1, "template"],
          showTransitionOptions: [1, "showTransitionOptions"],
          hideTransitionOptions: [1, "hideTransitionOptions"],
          autoClose: [1, "autoClose"],
          pauseLifeTime: [1, "pauseLifeTime"]
        },
        outputs: {
          onClose: "onClose"
        },
        decls: 1,
        vars: 1,
        consts: [["container", ""], [3, "ngClass"], [3, "value"], [1, "p-toast-message-content"], ["tabindex", "0", 1, "p-toast-close-icon"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "0", 1, "p-toast-close-icon", 3, "click", "keydown.enter"], ["icon", "times"], [1, "p-toast-icon", 3, "icon"], [1, "p-toast-message-text-content"], ["e2e-message-headline", "", 1, "p-toast-summary"], ["e2e-message-body", "", 1, "p-toast-detail", 3, "innerHTML"], [1, "p-toast-duplicate-count"]],
        template: function AppMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, AppMessageComponent_Conditional_0_Template, 7, 14, "div", 1);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = ctx.message()) ? 0 : -1, tmp_0_0);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, UiIconsModule, i2.UiIconComponent, MinimalUiModule, UiProgressBarComponent, i1.AsyncPipe],
        styles: [".p-toast-message[_ngcontent-%COMP%]{margin-top:5px}.p-toast-message[_ngcontent-%COMP%]   .p-toast-message-content[_ngcontent-%COMP%]{padding:.5em}.p-toast-message[_ngcontent-%COMP%]   .p-toast-message-text-content[_ngcontent-%COMP%]{margin-left:1.5em}.p-toast-message[_ngcontent-%COMP%]   .p-toast-icon[_ngcontent-%COMP%]{position:absolute;left:.5em;top:.5em;height:16px}.p-toast-message[_ngcontent-%COMP%]   .p-toast-close-icon[_ngcontent-%COMP%]{position:absolute;right:.5em;top:.5em;height:16px;margin-top:-4px}.p-toast-message[_ngcontent-%COMP%]   .p-toast-summary[_ngcontent-%COMP%]{font-size:16px;margin:-3px 0 0;padding:0 20px 0 0;display:flex}.p-toast-message[_ngcontent-%COMP%]   .p-toast-summary[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:first-child{flex:1}.p-toast-message[_ngcontent-%COMP%]   .p-toast-summary[_ngcontent-%COMP%] + .p-toast-detail[_ngcontent-%COMP%]{margin-top:.5em}.p-toast-message[_ngcontent-%COMP%]   .p-toast-summary[_ngcontent-%COMP%]   .p-toast-duplicate-count[_ngcontent-%COMP%]{display:block;border:1px solid rgba(0,0,0,.3);border-radius:10px;line-height:1;width:18px;height:18px;text-align:center;font-size:13px}.p-toast-message[_ngcontent-%COMP%]   .p-toast-detail[_ngcontent-%COMP%]{font-size:12px;line-height:1.35}.p-toast-message.has-lifetime[_ngcontent-%COMP%]{padding-bottom:6px}.p-toast-message.has-lifetime[_ngcontent-%COMP%]   ui-progressBar[_ngcontent-%COMP%]{position:absolute;bottom:0;left:0;right:0;margin:0;--progressBarBgColor: transparent;--progressBarValueBgColor: rgba(0,0,0,.3)}.p-toast-message[_ngcontent-%COMP%]{border:0 none}.p-toast-message.p-toast-message-info[_ngcontent-%COMP%]{background-color:var(--infoMessageBgColor);border-color:var(--infoMessageBorderColor);color:var(--infoMessageTextColor)}.p-toast-message.p-toast-message-info[_ngcontent-%COMP%]   .p-toast-close-icon[_ngcontent-%COMP%]{color:var(--infoMessageTextColor)}.p-toast-message.p-toast-message-success[_ngcontent-%COMP%]{background-color:var(--successMessageBgColor);border-color:var(--successMessageBorderColor);color:var(--successMessageTextColor)}.p-toast-message.p-toast-message-success[_ngcontent-%COMP%]   .p-toast-close-icon[_ngcontent-%COMP%]{color:var(--successMessageIconColor)}.p-toast-message.p-toast-message-warn[_ngcontent-%COMP%]{background-color:var(--warnMessageBgColor);border-color:var(--warnMessageBorderColor);color:var(--warnMessageTextColor)}.p-toast-message.p-toast-message-warn[_ngcontent-%COMP%]   .p-toast-close-icon[_ngcontent-%COMP%]{color:var(--warnMessageTextColor)}.p-toast-message.p-toast-message-error[_ngcontent-%COMP%]{background-color:var(--errorMessageBgColor);border-color:var(--errorMessageBorderColor);color:var(--errorMessageTextColor)}.p-toast-message.p-toast-message-error[_ngcontent-%COMP%]   .p-toast-close-icon[_ngcontent-%COMP%]{color:var(--errorMessageTextColor)}"],
        data: {
          animation: [trigger('messageState', [state('visible', style({
            transform: 'translateY(0)',
            opacity: 1
          })), transition('void => *', [style({
            transform: 'translateY(100%)',
            opacity: 0
          }), animate('{{showTransitionParams}}')]), transition('* => void', [animate('{{hideTransitionParams}}', style({
            height: 0,
            opacity: 0,
            transform: 'translateY(-100%)'
          }))])])]
        },
        changeDetection: 0
      });
    }
  }
  return AppMessageComponent;
})();